import { BaseListResponseDto, PaginationQueryParams } from './common.dtos';

export enum OrderTypeDto {
  Market = 'Market',
  Limit = 'Limit',
  StopMarket = 'Stop_Market',
  StopLimit = 'Stop_Limit',
  MarketOnClose = 'Market_On_Close',
}

export enum TradingBlockOrderTypeNumberEnum {
  Undefined = 0,
  Market = 1,
  Limit = 2,
  Stop_Market = 3,
  Stop_Limit = 4,
  Market_On_Close = 5,
}

export enum TradingBlockOrderActionNumberEnum {
  Undefined = 0,
  Buy = 1,
  Sell = 2,
}

export enum OrderActionDto {
  Buy = 'Buy',
  Sell = 'Sell',
}

// Deprecated: use order action dto
export enum TradingBlockOrderActionEnum {
  Buy = 'Buy',
  Sell = 'Sell',
}

export enum OrderDurationDto {
  Day = 'Day',
  GTC = 'GTC',
}

// Deprecated: use order duration dto
export enum TradingBlockOrderDurationEnum {
  Day = 'Day',
  GTC = 'GTC',
}

export enum OrderDurationNumberDto {
  Day = 1,
  GTC = 2,
}

export enum TradingBlockOrderStatusEnum {
  Undefined = 0,
  New,
  PartiallyFilled,
  Filled,
  DoneForDay,
  Cancelled,
  Replaced,
  PendingCancel,
  Stopped,
  Rejected,
  Suspended,
  PendingNew,
  Calculated,
  Expired,
  PendingReplace,
  Saved,
  LiveUntriggered,
  Scheduled,
  OCO_Untriggered,
  CancelledUntriggered,
  Initiated,
  ReplaceInitiated,
  CancelInitiated,
  CancelRejected,
  ReplaceRejected,
  Busted,
  PreAllocated,
  Acknowledged,
  PartiallyCancelled,
}

export interface OrderDto {
  AccountId: number;
  AllOrNone: boolean;
  AverageFillPrice?: number;
  BypassWarnings?: boolean;
  ClientRefId?: number;
  CommissionType?: string;
  CommissionAssessed: number;
  Date: string;
  Description?: string;
  Duration: TradingBlockOrderDurationEnum;
  FillQuantity?: number;
  Legs?: Array<{
    Action?: TradingBlockOrderActionNumberEnum;
    AssetType?: string;
    AverageLegFillPrice?: number;
    CallPut?: boolean;
    LegFillQuantity?: number;
    PositionEffect?: string;
    SpreadRatio?: number;
    Symbol?: string;
  }>;
  OrderId: number;
  OrderStatus: TradingBlockOrderStatusEnum;
  OrderType: TradingBlockOrderTypeNumberEnum;
  Price?: number;
  Quantity: number;
  Stop?: number;
  UnderlyingSymbol?: string;
}

interface BaseOrderParamsDto {
  accountId: number;
}

export type CreateOrderBodyDto = {
  duration?: OrderDurationDto;
  orderType?: OrderTypeDto;
  action?: OrderActionDto;
  price?: number;
  stop?: number;
  quantity?: number;
  symbol?: string;
};

export interface CreateOrderDto {
  params: BaseOrderParamsDto;
  body: CreateOrderBodyDto;
}

export interface GetOrderParamsDto extends BaseOrderParamsDto {
  id: string;
}

export interface GetOrderDto {
  params: GetOrderParamsDto;
}

export interface CancelOrderParamsDto extends BaseOrderParamsDto {
  id: string;
}

export interface CancelOrderDto {
  params: CancelOrderParamsDto;
}

export interface GetOrderListQueryParamsDto extends PaginationQueryParams {
  dateFrom?: string;
  dateTo?: string;
  symbol?: string;
}

export interface GetOrderListDto {
  params: BaseOrderParamsDto;
  queryParams?: GetOrderListQueryParamsDto;
}

export interface GetOrderListResponseDto extends BaseListResponseDto<OrderDto[]> {}
